import isEqual from 'fast-deep-equal';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';
import { createWithEqualityFn } from 'zustand/traditional';

import { CompositeState, ICompositeState } from 'types/pages/audience-builder/shared/composite';

const initialState: ICompositeState = {
  isOpen: false,
};

const action = (name: string) => ({ type: `composite/${name}` });

export const useCompositeStore = createWithEqualityFn<CompositeState>()(
  immer(
    devtools((set, _) => ({
      ...initialState,
      reset: () => set({ ...initialState }, false, action('reset')),
      setIsOpen: (value) => set({ isOpen: value }, false, action('setIsOpen')),
    }))
  ),
  isEqual
);
